export const CLIENT_TYPES = [
  { label: "Select Client Type", value: "" },
  { label: "Individual", value: "individual" },
  { label: "Organization", value: "organization" },
];

export const COMPANY_SIZES = [
  { label: "Select Company Size", value: "" },
  { label: "1-10 Employees", value: "10" },
  { label: "11-50 Employees", value: "50" },
  { label: "51-200 Employees", value: "200" },
  { label: "201-500 Employees", value: "2500" },
  { label: "501+ Employees", value: "501" },
];

export const PAYMENT_TERMS = [
  { label: "Select Payment Terms", value: "" },
  { label: "Net 15", value: "net15" },
  { label: "Net 30", value: "net30" },
  { label: "Net 45", value: "net45" },
  { label: "Net 60", value: "net60" },
  { label: "Advance", value: "advance" },
];

export const BANK_LIST = [
  "AU Small Finance Bank Limited",
  "Axis Bank",
  "Bandhan Bank",
  "Bank of Baroda",
  "Bank of India",
  "Bank of Maharashtra",
  "Canara Bank",
  "Central Bank Of India",
  "City Union Bank",
  "CSB Bank Limited",
  "DCB Bank Limited",
  "Dhanalakshmi Bank",
  "Federal Bank",
  "HDFC Bank",
  "ICICI Bank Limited",
  "IDBI Bank",
  "IDFC First Bank Limited",
  "Indian Bank",
  "Indian Overseas Bank",
  "Indusind Bank",
  "Jammu and Kashmir Bank",
  "Karur Vysya Bank",
  "Karnataka Bank Limited",
  "Kotak Mahindra Bank Limited",
  "The Nainital Bank Limited",
  "Punjab and Sind Bank",
  "Punjab National Bank",
  "RBL Bank Limited",
  "South Indian Bank",
  "State Bank of India",
  "Tamilnad Mercantile Bank Limited",
  "UCO Bank",
  "Union Bank of India",
  "Yes Bank",
].sort();
